/**
 * Workspace Service REST API
 *
 * Contact: ContactRequests@enverus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Currency {
    code?: string;
    provider?: string;
    base?: string;
    currency?: string;
    currencyType?: Currency.CurrencyTypeEnum;
    divisor?: number;
}
export namespace Currency {
    export const CurrencyTypeEnum = {
        Spot: 'SPOT',
        Forward: 'FORWARD'
    } as const;
    export type CurrencyTypeEnum = (typeof CurrencyTypeEnum)[keyof typeof CurrencyTypeEnum];
}
